module.exports = __webpack_public_path__ + "static/media/bitterpeach-removebg-preview.6dfe48f8.png";